import React,{useState ,useEffect,useContext } from 'react';
import { Row, Col, Button, Space ,Modal, Table, notification,message, } from 'antd';
import { Link } from 'react-router-dom';
import { BellOutlined } from '@ant-design/icons';
import api from '../../api/axios';
import { AuthContext } from '../../context/AuthContext';
// Table columns for attachments
import { v4 as uuidv4 } from 'uuid';

const SalesManagerDashboard = () => {
    const { user } = useContext(AuthContext);
    const shopId = user?.shopId;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [messageApi,contextHolder] = message.useMessage();
 const [attachmentData, setAttachmentData] = useState([]); // State to store fetched attachments
  const [loading, setLoading] = useState(false); // Loading state for the API call
 const fetchAttachments = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/api/attachment/today/${shopId}`); // Replace with your actual API URL
      setAttachmentData(response.data.attachments); // Store fetched attachments in the state
      console.log(response.data)
    } catch (error) {
      console.error('Error fetching attachments:', error);
      messageApi.error('Error fetching attachment')
    } finally {
      setLoading(false); // Set loading to false after the API call
    }
  };
   useEffect(() => {
    fetchAttachments();
  }, []);

  // Function to handle notification bell click
  const handleNotificationClick = () => {
    setIsModalVisible(true);
  };
const columns = [
  {
    title: 'Customer Name',
    dataIndex: 'customerName',
    key: 'customerName',
  },
  {
    title: 'Customer TIN',
    dataIndex: 'customerTIN',
    key: 'customerTIN',
  },
  {
    title: 'Sales Date',
    dataIndex: 'salesDate',
    key: 'salesDate',
  },
  {
    title: 'Sales Time',
    dataIndex: 'salesTime',
    key: 'salesTime',
  },
  {
    title: 'Status',
    key: 'status',
    render: (_, record) => (
      <Button onClick={() => handleToggleStatus(record)} type="link">
        {record.status ? 'Mark as Print' : 'Mark'}
      </Button>
    ),
  },
  {
    title: 'Action',
    key: 'action',
    render: (_, record) => (
      <Button onClick={() => handleViewAttachment(record)} type="link">
        View
      </Button>
    ),
  },
];
 const handleToggleStatus = async (record) => {
    try {
      const newStatus = !record.status;
      const response = await api.put(`/api/attachment/${record.id}`, { status: newStatus });
      
      if (response.status === 200) {
        // Update the status in the local state
        setAttachmentData((prevData) =>
          prevData.map((item) =>
            item.id === record.id ? { ...item, status: newStatus } : item
          )
        );
        messageApi.success('Status Updated');
      }
    } catch (error) {
      console.error('Error toggling status:', error);
      messageApi.error('Error updating status');
    }
  };



const handleViewAttachment = (attachment) => {
  const { items, customerName, customerTIN, refNo, fsNo, salesDate, salesTime, shop, grandTotal, itemCount, vatAmount } = attachment || {};

  const numberToWords = (num) => {
    if (num === 0) return 'Zero';
    const belowTwenty = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
      "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
    const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
    const thousands = ["", "Thousand", "Million", "Billion"];

    const helper = (n) => {
      if (n === 0) return "";
      else if (n < 20) return belowTwenty[n] + " ";
      else if (n < 100) return tens[Math.floor(n / 10)] + " " + helper(n % 10);
      else return belowTwenty[Math.floor(n / 100)] + " Hundred " + helper(n % 100);
    };

    let word = "";
    let i = 0;
    while (num > 0) {
      if (num % 1000 !== 0) {
        word = helper(num % 1000) + thousands[i] + " " + word;
      }
      num = Math.floor(num / 1000);
      i++;
    }
    return word.trim();
  };

  // Fix the saleDate and saleTime concatenation
   const saleDateTime = new Date(salesDate).toLocaleDateString('en-GB'); // If saleTime exists, combine it with saleDate, else use saleDate alone.

  const formattedDateTime = saleDateTime.toLocaleString('en-GB', { hour12: false }).replace(",", "") +" "+ salesTime; // This combines the date and time in the format 'dd/mm/yyyy HH:mm'

  // Format saleDate to 'dd/mm/yyyy' without time
  const formattedDateOnly = new Date(salesDate).toLocaleDateString('en-GB');

  const printWindow = window.open('', '_blank');
  printWindow.document.write(`
    <html lang="en">
      <head>
        <title>Invoice</title>
        <style>
          @page { size: A4; margin: 5mm; }
          body { font-family: "Times New Roman", serif; font-size: 12px; margin: 0; padding: 0; position: relative; }
          .container { padding: 40px; position: relative; min-height: 297mm; }
          
          /* Watermark Style - Fixed and Diagonal */
          .watermarkStyle {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-45deg);
            font-size: 102px;
            font-family: Arial, sans-serif;
            color: rgba(200, 200, 200, 0.2);
            z-index: -1; /* Ensure watermark is behind the content */
            pointer-events: none; /* Prevent watermark from interfering with interactions */
            white-space: nowrap;
          }

          .topper {
            position: absolute;
            top: 5mm;
            right: 5mm;
            margin-bottom: 20mm;
            font-size: 10px;
            text-align: right;
            width: 100%;
          }

          .header { 
            font-size: 22px; 
            font-weight: bold; 
            text-align: left; 
            margin: 0; 
            margin-top: 20px;  
            text-transform: uppercase;
          }

          .header2 { 
            font-size: 12px;
            font-weight: bold;  
            text-align: left; 
            margin: 0; 
            text-transform: uppercase; 
          }

          .title { 
            font-size: 22px; 
            text-align: center; 
            margin: 20px 0; 
          }

          table { 
            width: 100%; 
            border-collapse: collapse; 
            margin: 10px 0; 
            font-size: 11px; 
          }

          th, td { 
            border: 1px solid #000; 
            padding: 5px; 
          }

          .totals-table { 
            width: 40%; 
            float: right; 
            margin-top: 20px; 
            border-collapse: collapse; 
          }

          .totals-table td { 
            border: 1px solid #000; 
            padding: 5px; 
            text-align: left; 
          }

          .footer { 
            position: absolute; 
            bottom: 100px; 
            width: 100%; 
            font-size: 11px; 
          }

          .customer-table { 
            width: 100%; 
            border-collapse: separate; 
            border-spacing: 2px; 
          }

          .customer-table td { 
            border: 1px solid #000; 
            padding: 2px; 
            font-size: 11px; 
          }
        </style>
      </head>
      <body>
        <div class="container">
          <div class="watermarkStyle">ATTACHMENT</div>

          <p class="topper">${uuidv4()} | ${formattedDateTime}</p>
          <p class="header">${shop.header1 || 'SHOP NAME'}</p>
          <p class="header2">${shop.header2 || 'SHOP ADDRESS'}</p>
          <p class="header2">TEL: ${shop.header3 || 'PHONE'}</p>
          <p class="header2">TIN: ${shop.header4 || 'TIN'}</p>
          <p class="header2">${shop.header5 || ''}</p>

          <h2 class="title">Cash Sales Attachment</h2>

          <table class="customer-table">
            <tbody>
              <tr>
                <td>Date:</td>
                <td>${formattedDateOnly}</td>
                <td>Reference:</td>
                <td>CSI-ST<sub>1-01-${refNo || ''}</sub></td>
              </tr>
              <tr>
                <td>Bill To:</td>
                <td>${customerName || ''}</td>
                <td>FS NO:</td>
                <td>${fsNo || ''}</td>
              </tr>
              <tr>
                <td>TIN:</td>
                <td>${customerTIN || ''}</td>
              </tr>
              <tr>
                <td>Address:</td>
                <td></td>
              </tr>
            </tbody>
          </table>

          <div style="height: 20px;"></div>

          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Description</th>
                <th>Unit</th>
                <th>Quantity</th>
                <th>Unit Price</th>
                <th>Line Total</th>
              </tr>
            </thead>
            <tbody>
              ${items.map(item => `
                <tr>
                  <td>${item.partNumber}</td>
                  <td>${item.partName}</td>
                  <td>${item.unit}</td>
                  <td style="text-align: right">${item.quantity}</td>
                  <td style="text-align: right">${item.price.toFixed(2)}</td>
                  <td style="text-align: right">${(item.price * item.quantity).toFixed(2)}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>

          <div style="height: 30px;"></div>

          <table class="totals-table">
            <tbody>
              <tr>
                <td>Subtotal:</td>
                <td style="text-align: right">${grandTotal.toFixed(2)}</td>
              </tr>
              ${vatAmount > 0 ? `
                <tr>
                  <td>VAT:</td>
                  <td style="text-align: right">${vatAmount.toFixed(2)}</td>
                </tr>
              ` : ''}
              <tr>
                <td><strong>Grand Total:</strong></td>
                <td style="text-align: right"><strong>${(grandTotal + vatAmount).toFixed(2)}</strong></td>
              </tr>
            </tbody>
          </table>

          <div style="float: left; margin-top: 45px;">
            Payment Method - <br />
            Amount in Words: ${numberToWords(Math.round(grandTotal))} Only
          </div>

          <div class="footer">
          
            <p>Prepared by: m</p>
              <p>${shop.footer1 || ''}</p>
            <p>Received by: Name ________________________ Signature _________________________</p>
            <p><strong>NOT VALID WITHOUT FISCAL RECEIPT ATTACHED</strong></p>
          </div>
        </div>
      </body>
    </html>
  `);
  printWindow.document.close();
  printWindow.print();
};




  // Function to close the modal
  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  return (
    <div style={{ padding: 16, textAlign: 'right' }}>
      {contextHolder}
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Link to="/sales/new-sale">
          <Button
            type="primary"
            size="large"
            style={{
              width: 250,
              height: 80,
              fontSize: 16,
              fontWeight: 'bold',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 12,
              boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
            }}
          >
            Add New Sale
            <span style={{ fontSize: 12, fontWeight: 'normal' }}>Create a new sales record</span>
          </Button>
        </Link>

        <Link to="/sales/proforma">
          <Button
            type="default"
            size="large"
            style={{
              width: 250,
              height: 80,
              fontSize: 16,
              fontWeight: 'bold',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 12,
              boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
            }}
          >
            Create Proforma
            <span style={{ fontSize: 12, fontWeight: 'normal' }}>Generate proforma invoice</span>
          </Button>
        </Link>

        <Link to="/sales/search">
          <Button
            type="dashed"
            size="large"
            style={{
              width: 250,
              height: 80,
              fontSize: 16,
              fontWeight: 'bold',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 12,
              boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
            }}
          >
            Send Spare Request
            <span style={{ fontSize: 12, fontWeight: 'normal' }}>Search and sent spare parts</span>
          </Button>
        </Link>

        <Link to="/sales/accept">
          <Button
            type="default"
            size="large"
            style={{
              width: 250,
              height: 80,
              fontSize: 16,
              fontWeight: 'bold',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 12,
              boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
            }}
          >
            Accept Spare Request
            <span style={{ fontSize: 12, fontWeight: 'normal' }}>Accept incoming spare parts</span>
          </Button>
        </Link>
         <Link to="/sales/transfer">
          <Button
            type="default"
            size="large"
            style={{
              width: 250,
              height: 80,
              fontSize: 16,
              fontWeight: 'bold',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 12,
              boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
            }}
          >
            Transfer Spare Request
            <span style={{ fontSize: 12, fontWeight: 'normal' }}>Transfer spare parts request</span>
          </Button>
        </Link>
         <div onClick={handleNotificationClick} style={{ cursor: 'pointer' }}>
          <BellOutlined style={{ fontSize: 40, color: '#1890ff' }} />
        </div>

        {/* Modal to show attachments */}
        <Modal
          title="Attachments"
          visible={isModalVisible}
          onCancel={handleCloseModal}
          footer={null}
          width={800}
        >
          <Table
            columns={columns}
            dataSource={attachmentData}
            pagination={false}
            rowKey="key"
          />
        </Modal>
      </Space>
    </div>
  );
};

export default SalesManagerDashboard;
